import { Api, Codes } from 'api';
import _Time from 'utils/time';
const Time = new _Time();
const getCountdown = diff => {
  let ret = {
    day: 0,
    dayStr: '',
    hour: 0,
    hourStr: '',
    minute: 0,
    minuteStr: '',
    second: 0,
    secondStr: ''
  };
  diff = diff / 1000;
  ret.second = parseInt(diff % 60);
  ret.secondStr = ret.second < 10 ? `0${ret.second}` : ret.second;
  diff = Math.floor(diff / 60);
  ret.minute = parseInt(diff % 60);
  ret.minuteStr = ret.minute < 10 ? `0${ret.minute}` : ret.minute;
  diff = Math.floor(diff / 60);
  ret.hour = parseInt(diff % 24);
  ret.hourStr = ret.hour < 10 ? `0${ret.hour}` : ret.hour;
  diff = Math.floor(diff / 24);
  ret.day = diff;
  ret.dayStr = ret.day < 10 ? `0${ret.day}` : ret.day;
  return ret;
};
export default {
  state: () => ({
    deadlines: [],
    eb1Diff: Infinity,
    eb2Diff: Infinity,
    mrdDiff: Infinity,
    rdDiff: Infinity
  }),
  mutations: {
    setDDLs: (state, payload) => {
      if (payload.promise) {
        state.deadlines = payload.promise;
      } else {
        state.deadlines = payload.data || [];
      }
    },
    setEB1Diff: (state, payload) => {
      state.eb1Diff = payload.data;
    },
    setEB2Diff: (state, payload) => {
      state.eb2Diff = payload.data;
    },
    setMrdDiff: (state, payload) => {
      state.mrdDiff = payload.data;
    },
    setRdDiff: (state, payload) => {
      state.rdDiff = payload.data;
    }
  },
  getters: {
    eb1Countdown: state => {
      return getCountdown(state.eb1Diff);
    },
    eb1RemainDays: state => {
      let days = state.eb1Diff / 1000 / 60 / 60 / 24;
      return parseInt(days) < days ? parseInt(days) + 1 : parseInt(days);
    },
    eb2RemainDays: state => {
      let days = state.eb2Diff / 1000 / 60 / 60 / 24;
      return parseInt(days) < days ? parseInt(days) + 1 : parseInt(days);
    },
    mrdCountdown: state => {
      return getCountdown(state.mrdDiff);
    },
    mrdRemainDays: state => {
      let days = state.mrdDiff / 1000 / 60 / 60 / 24;
      return parseInt(days) < days ? parseInt(days) + 1 : parseInt(days);
    },
    isRdOver: state => {
      return state.rdDiff < 0;
    },
    getDDLItem: state => key => {
      if (state.deadlines instanceof Promise) {
        return {};
      } else {
        return state.deadlines.find(item => item.key === key) || {};
      }
    }
  },
  actions: {
    startMrdCountdown: async ({ commit, dispatch }) => {
      let interval = setInterval(async () => {
        let ddl = await dispatch('getDDLItem', '学生报名MRD');
        let diff = Time.getDiff(ddl.deadline);
        commit('setMrdDiff', {
          data: diff
        });
        if (diff < 0) {
          clearInterval(interval);
        }
      }, 1000);
    },
    startEB1Countdown: async ({ commit, dispatch }) => {
      let interval = setInterval(async () => {
        let ddl = await dispatch('getDDLItem', '学生报名EB1');
        let diff = Time.getDiff(ddl.deadline);
        commit('setEB1Diff', {
          data: diff
        });
        if (diff < 0) {
          clearInterval(interval);
        }
      }, 1000);
    },
    startEB2Countdown: async ({ commit, dispatch }) => {
      let interval = setInterval(async () => {
        let ddl = await dispatch('getDDLItem', '学生报名EB2');
        let diff = Time.getDiff(ddl.deadline);
        commit('setEB2Diff', {
          data: diff
        });
        if (diff < 0) {
          clearInterval(interval);
        }
      }, 1000);
    },
    startRdCountdown: async ({ commit, dispatch }) => {
      let interval = setInterval(async () => {
        let ddl = await dispatch('getDDLItem', '学生报名RD');
        let diff = Time.getDiff(ddl.deadline);
        commit('setRdDiff', {
          data: diff
        });
        if (diff < 0) {
          clearInterval(interval);
        }
      }, 1000);
    },
    getDDLItem: async ({ dispatch }, key) => {
      let ddls = await dispatch('getDDLs');
      return ddls.find(item => item.key === key) || {};
    },
    getDDLs: ({ commit, state }) => {
      let deadlines = state.deadlines;
      if (deadlines instanceof Promise) {
        return deadlines;
      } else {
        if (state.deadlines.length) {
          return new Promise(resolve => {
            resolve(state.deadlines);
          });
        } else {
          const promise = new Promise(resolve => {
            let ret = [];
            if (state.deadlines.length) {
              resolve(state.deadlines);
            } else {
              Api.get.getDDL().then(res => {
                if (res.status === Codes.SUCCESS && res.data) {
                  ret = Object.keys(res.data).map(key => ({
                    deadline: res.data[key],
                    key
                  }));
                  commit('setDDLs', { data: ret });
                  resolve(ret);
                } else {
                  resolve(ret);
                }
              });
            }
          });
          commit('setDDLs', { promise });
          return promise;
        }
      }
    }
  }
};
